import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, extractError } from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  // state: null = loading, false = unauthenticated, object = authenticated
  const [user, setUser] = useState(null);
  const [company, setCompany] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      setCompany(data.company);
      return data;
    } catch (e) {
      setUser(false);
      setCompany(null);
      return null;
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (identifier, password) => {
    const { data } = await api.post("/auth/login", { identifier, password });
    await refresh();
    return data;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    await refresh();
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    setUser(false);
    setCompany(null);
  };

  return (
    <AuthContext.Provider value={{ user, company, setCompany, refresh, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}

export { extractError };
